import { APIProvider, Map, Marker } from "@vis.gl/react-google-maps"

export const MapMarker = ({ lat, long }: { lat: number; long: number }) => {
  const position = {
    lat: lat,
    lng: long,
  }

  return (
    <>
      <APIProvider apiKey={import.meta.env.VITE_GMAPS}>
        <Map
          zoom={10}
          center={position}
          style={{ width: "100%", height: "300px" }}
        >
          <Marker position={position} />
        </Map>
      </APIProvider>
    </>
  )
}
